import H from '@here/maps-api-for-javascript/bin/mapsjs.bundle.harp'
import { createContext } from 'react'

// Modules singleton instance for Map
let mapInstance: H.Map | undefined = undefined

export interface DisposableMap extends H.Map {
  dispose: () => void
}

export function createMap(
  element?: HTMLDivElement,
  baseLayer?: H.map.layer.Layer,
  options?: H.Map.Options,
  onContextMenu?: (map: H.Map, event: H.mapevents.ContextMenuEvent) => void,
  onPoiTap?: (map: H.Map, event: H.mapevents.Event) => void
): DisposableMap {
  const isMapInstanceFirstCreateCall =
    !mapInstance && element !== undefined && baseLayer !== undefined && options !== undefined
  if (isMapInstanceFirstCreateCall) {
    const engineType = H.Map.EngineType['HARP']
    const map = new H.Map(element, baseLayer, {
      ...options,
      engineType,
    })
    const t = new H.mapevents.MapEvents(map)

    if (onContextMenu !== undefined) {
      map.addEventListener('contextmenu', (event: H.mapevents.ContextMenuEvent): void =>
        onContextMenu(map, event)
      )
    }
    if (onPoiTap !== undefined) {
      map
        .getBaseLayer()
        ?.getProvider()
        .addEventListener('tap', (event: H.mapevents.Event) => onPoiTap(map, event))
    }

    new H.mapevents.Behavior(t)

    mapInstance = map
    return map as unknown as DisposableMap
  }

  return mapInstance as unknown as DisposableMap
}

export const MapContext = createContext<GeolocationPosition | null>(null)
